import { PartialTheme } from './styles';

export const ptsdTheme = {
  color: {
    primary100: '#007991',
    primary200: '#48C5C5',
    primary300: '#BFE9E9',
    dark: '#222E50',
    accent100: '#49AB94',
    accent200: '#BBE3C2',
    accent300: '#DFF1EC',
    accentTwo100: '#FF8F4B',
    accentTwo200: '#FFBC93',
    accentTwo300: '#FFE3D2',
    accentThree100: '#F1BC52',
    accentThree200: '#F7D797',
    accentThree300: '#FBEED3',
  },
} satisfies PartialTheme;

export const STRESS_BREATHING_ROUND_COLORS = [
  ptsdTheme.color.accentTwo100,
  '#4668CA',
  ptsdTheme.color.primary100,
  ptsdTheme.color.accent100,
  ptsdTheme.color.primary200,
];
